// Conversion inverse : transforme une valeur physique en valeur brute (mA, V…)
// selon la calibration d'un nœud. Utilisé par la page Simulateur pour mimer
// un vrai capteur câblé : l'utilisateur saisit du physique, le serveur reçoit du brut.

const PRESETS = {
  '4-20mA': { minRaw: 4, maxRaw: 20 },
  '0-10V':  { minRaw: 0, maxRaw: 10 },
};

export function inverseCalibration(physique, calibration) {
  if (typeof physique !== 'number' || !isFinite(physique)) return physique;
  if (!calibration || !calibration.mode || calibration.mode === 'none') return physique;

  const preset = PRESETS[calibration.mode] || {};
  const minRaw = calibration.minRaw ?? preset.minRaw;
  const maxRaw = calibration.maxRaw ?? preset.maxRaw;
  const { minPhysique, maxPhysique } = calibration;

  if (typeof minRaw !== 'number' || typeof maxRaw !== 'number'
   || typeof minPhysique !== 'number' || typeof maxPhysique !== 'number'
   || maxPhysique === minPhysique) {
    return physique;
  }
  return minRaw + (physique - minPhysique) * (maxRaw - minRaw) / (maxPhysique - minPhysique);
}

export function rawUnitForMode(mode) {
  if (mode === '0-10V') return 'V';
  if (mode === '4-20mA' || mode === 'linear') return 'mA';
  return null;
}
